<router-outlet></router-outlet>

<app-loader></app-loader>
<span *ngIf="showVersion" style="position: fixed; bottom: 16px; right: 16px; opacity: 0.5; z-index: 1000">
  Versão: {{ version }} | Angular: {{ angularVersion }}
</span>
